import { render, staticRenderFns } from "./PriceDropIcon.vue?vue&type=template&id=6497323a&scoped=true&"
import script from "./PriceDropIcon.vue?vue&type=script&lang=js&"
export * from "./PriceDropIcon.vue?vue&type=script&lang=js&"
import style0 from "./PriceDropIcon.vue?vue&type=style&index=0&id=6497323a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6497323a",
  null
  
)

export default component.exports